import React, { memo } from 'react';
import { Box, Text } from 'components/Wrapped';

const TradeModeSwitcher = memo(({ tradeMode, onChangeTradeMode }) => (
  <Box direction="row" gap="2px" flex={{ shrink: 0 }} pad="none" height="38px">
    <Box
      background={tradeMode === 'buy' ? '#46B08E' : 'transparent'}
      justify="center"
      align="center"
      pad="11px"
      fill={true}
      style={{
        borderRadius: '40px 2px 2px 40px',
        cursor: 'pointer',
      }}
      onClick={() => onChangeTradeMode('buy')}
    >
      <Text color={true ? 'white' : '#B4B6B7'} size="12px" weight={600} style={{ lineHeight: '16px' }}>
        Купить
      </Text>
    </Box>
    <Box
      background={tradeMode === 'sell' ? '#C55445' : 'transparent'}
      justify="center"
      align="center"
      pad="11px"
      fill={true}
      style={{
        borderRadius: '2px 40px 40px 2px',
        cursor: 'pointer',
      }}
      onClick={() => onChangeTradeMode('sell')}
    >
      <Text color={true ? 'white' : '#B4B6B7'} size="12px" weight={600} style={{ lineHeight: '16px' }}>
        Продать
      </Text>
    </Box>
  </Box>
));

export default TradeModeSwitcher;
